import type { CreatorsV2Filter, LoadAdvertisersForCriteria } from '@metapic-apps/shared'
import { computed, type Ref } from 'vue'

import { useGetAdvertiserListRequest } from '@/api/advertisers.api'
import { useGetUserListRequest, useGetUsersFromArrayRequest } from '@/api/users.api'

export const createLoadAdvertisersForCriteria =
  (advertiserGroupId: Ref<number | undefined>): LoadAdvertisersForCriteria =>
  (filterRef) => {
    const query = computed(() => filterRef.value.query)
    const { data, isLoading, error } = useGetAdvertiserListRequest(advertiserGroupId, query)

    return {
      data: computed(() =>
        data.value.map((advertiser) => ({
          id: advertiser.id,
          label: advertiser.label,
          currency: advertiser.currency,
        })),
      ),
      isLoading,
      error,
    }
  }

const CREATOR_OPTIONS_PAGE_SIZE = 10

export const loadCreatorsForSegment = (filterRef: Ref<CreatorsV2Filter>) => {
  const cappedFilter = computed<CreatorsV2Filter>(() => ({
    ...filterRef.value,
    size: CREATOR_OPTIONS_PAGE_SIZE,
  }))

  return useGetUserListRequest(cappedFilter)
}

export const matchCreatorsForSegment = (
  advertiserGroupId: Ref<number | undefined>,
  tokens: Ref<string[]>,
) => {
  const resolvedAdvertiserGroupId = computed(() => advertiserGroupId.value ?? 0)

  return useGetUsersFromArrayRequest(resolvedAdvertiserGroupId, tokens)
}
